module.exports = __webpack_public_path__ + "static/media/air-pollution-and-the-curse.88be7328.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/air-pollution-and-the-curse.jpg
// module id = 782
// module chunks = 0